import { Spinner, SpinnerSize } from '@fluentui/react';
import 'office-ui-fabric-react/dist/css/fabric.css';
import { UserSubscriptionsType } from '@/services/SubscriptionService';
import ServiceSubscriptionTable from './ServiceSubscriptionTable';

interface ServiceSubscriptionTableLogicProps {
    subscriptions?: UserSubscriptionsType[];
    loading: boolean;
}

const ServiceSubscriptionTableLogic = (props: ServiceSubscriptionTableLogicProps) => {
    const { subscriptions, loading } = props;

    var columns = [
        {
            id: 'service',
            title: "Servicio"
        },
        {
            id: 'startDate',
            title: "Fecha de Inicio"
        },
        {
            id: 'endDate',
            title: "Fecha de Fin"
        },
        {
            id: 'status',
            title: "Estado"
        }
    ];

    if (loading) {
        return (<Spinner size={SpinnerSize.large} />);
    }
    else {
        return (
            <ServiceSubscriptionTable
                tableTitle={"Servicios del Cliente"}
                tableCount={subscriptions?.length}
                rowData={subscriptions as UserSubscriptionsType[]} columnTitles={columns}
            />
        );
    }
};

export default ServiceSubscriptionTableLogic;